import React from 'react';
import classnames from 'classnames';
import { DeliveryProvider, OrderMethod } from '../../services/exports/Constants';
import DeliveryProviderIcon from '../delivery/DeliveryProviderIcon';
import CutleryIcon from '../../resources/assets/icons/CutleryIcon';
import PickupIcon from '../../resources/assets/icons/PickupIcon';
import DeliveryIcon from '../../resources/assets/icons/DeliveryIcon';
import OrderHelpers from '../../services/helpers/OrderHelpers';

export const Sizes = {
  sm: 'sm',
  lg: 'lg',
  xl: 'xl',
};

export default function OrderMethodIcon({ order, className, size = Sizes.lg }) {
  const method = OrderHelpers.canonicalMethod(order);

  if (order.method === OrderMethod.Delivery && order.delivery_provider !== DeliveryProvider.Standalone) {
    const sizeClasses =
      {
        [Sizes.sm]: 'h-10 w-10',
        [Sizes.lg]: 'h-12 w-12',
        [Sizes.xl]: 'h-14 w-14',
      }[size] ?? null;

    return <DeliveryProviderIcon provider={order.delivery_provider} className={classnames(sizeClasses, className)} />;
  }

  const iconSizeClasses =
    {
      [Sizes.sm]:
        {
          [OrderMethod.OnSite]: 'h-6 w-6',
          [OrderMethod.Pickup]: 'h-9 w-9',
          [OrderMethod.Delivery]: 'h-8 w-8',
        }[method] ?? null,
      [Sizes.lg]:
        {
          [OrderMethod.OnSite]: 'h-8 w-8',
          [OrderMethod.Pickup]: 'h-12 w-12',
          [OrderMethod.Delivery]: 'h-12 w-12',
        }[method] ?? null,
      [Sizes.xl]:
        {
          [OrderMethod.OnSite]: 'h-10 w-10',
          [OrderMethod.Pickup]: 'h-14 w-14',
          [OrderMethod.Delivery]: 'h-14 w-14',
        }[method] ?? null,
    }[size] ?? null;

  const containerSizeClasses =
    {
      [Sizes.sm]: 'h-10 w-10',
      [Sizes.lg]: 'h-12 w-12',
      [Sizes.xl]: 'h-14 w-14',
    }[size] ?? null;

  const icon = {
    [OrderMethod.OnSite]: <CutleryIcon className={classnames('m-auto', iconSizeClasses, className)} />,
    [OrderMethod.Pickup]: <PickupIcon className={classnames('m-auto', iconSizeClasses, className)} />,
    [OrderMethod.Delivery]: <DeliveryIcon className={classnames('m-auto', iconSizeClasses, className)} />,
  }[method];

  return <div className={classnames('bg-gray-800 rounded-full flex', containerSizeClasses, className)}>{icon}</div>;
}
